export default __webpack_public_path__ + "static/media/forgot-pwd.d29ab966.png";